module.exports = __webpack_public_path__ + "static/media/margarida.ee6ab94b.jpg";